import { faLink, faUnlink } from '@fortawesome/pro-light-svg-icons'

import { Box, Form } from '@domain-group/suit-theme'

import { UseFormPayload } from '@domain-group/react-hooks'

import useSelector from '@hooks/useSelector'

import InfoToolTip from '@components/InfoToolTip'
import SuburbSearch from '@components/SuburbSearch'

import type { EntitiesState } from '@redux/entities'

import type { GeoSuburbModel } from '@models/types'

type HandleSelectItemParams = {
  geoStates: EntitiesState['geoStates'],
  geoSuburb: GeoSuburbModel,
  setEntityState: UseFormPayload['setEntityState'],
}

const handleSelectItem = (params: HandleSelectItemParams) => {
  const { geoStates, geoSuburb, setEntityState } = params

  setEntityState({
    post_code: geoSuburb?.post_code,
    state_id: geoSuburb?.geo_state_id,
    state_name: geoStates[geoSuburb.geo_state_id]?.code,
    suburb_id: geoSuburb?.id,
    suburb_name: geoSuburb?.title,
  })
}

interface SuburbProps {
  campaignForm: UseFormPayload,
  geo_country_id?: number,
}

const Suburb = (props: SuburbProps) => {
  const {
    campaignForm, geo_country_id,
  } = props

  const {
    entityState: {
      suburb_id,
      suburb_name,
    },
    errors,
    setEntityState,
  } = campaignForm

  const { geoStates } = useSelector(reduxState => reduxState.entities)

  const isLinkedSuburb = !!suburb_id

  return (
    <Form.Field
      errorMessage={errors.suburb_name}
      // @ts-expect-error TS2322
      label={(
        <>
          <Box marginRight="small">* Suburb</Box>

          <InfoToolTip icon={isLinkedSuburb ? faLink : faUnlink}>
            {isLinkedSuburb ? 'Campaign Suburb is linked' : 'Campaign Suburb is not linked'}
          </InfoToolTip>
        </>
      )}
      // @ts-expect-error TS2322
      marginTop={['large', 0]}
    >
      <SuburbSearch
        callbacks={{
          onChange: (value: string) => setEntityState({ suburb_name: value }),
          selectItem: (geoSuburb: GeoSuburbModel) => handleSelectItem({ geoStates, geoSuburb, setEntityState }),
        }}
        requestOptions={{ geo_country_id }}
        value={suburb_name}
      />
    </Form.Field>
  )
}

export default Suburb
